import type {
  AttributeWithBooleanValueFilter,
  AttributeWithValuesFilter,
  ProductSearchQuery,
} from '@scayle/storefront-nuxt'
import type { LocationQuery, LocationQueryValue } from 'vue-router'

const NON_LISTING_QUERY_KEYS = new Set([
  'searchMode',
  'q',
  'gclid',
  'fbclid',
  'msclkid',
  'dclid',
  'twclid',
  'li_fat_id',
  'ref',
])

const LISTING_CONTROL_QUERY_KEYS = new Set(['page', 'sort'])

export const isPlpListingQueryKey = (key: string) =>
  !NON_LISTING_QUERY_KEYS.has(key) && !key.startsWith('utm_')

const getAttributeValues = (
  value: LocationQueryValue | LocationQueryValue[],
): number[] => {
  if (value == null) {
    return []
  }

  const values = Array.isArray(value) ? value : String(value).split(',')
  return values.map((entry) => Number(entry)).filter(Number.isFinite)
}

export const parseAppliedFilters = (
  query: LocationQuery,
): ProductSearchQuery => {
  const productSearchQuery: ProductSearchQuery = { attributes: [] }

  Object.entries(query).forEach(([filterName, value]) => {
    if (
      !value ||
      LISTING_CONTROL_QUERY_KEYS.has(filterName) ||
      !isPlpListingQueryKey(filterName)
    ) {
      return
    }

    const firstValue = Array.isArray(value) ? value[0] : value
    if (!firstValue) {
      return
    }

    switch (filterName) {
      case 'minPrice':
      case 'maxPrice':
        if (isNaN(Number(firstValue))) {
          return
        }
        productSearchQuery[filterName] = Number(firstValue)
        break
      case 'term':
        productSearchQuery.term = firstValue
        break
      default: {
        if (firstValue === 'true' || firstValue === 'false') {
          const booleanFilter: AttributeWithBooleanValueFilter = {
            type: 'boolean',
            key: filterName,
            value: firstValue === 'true',
          }
          productSearchQuery.attributes?.push(booleanFilter)
          return
        }

        const values = getAttributeValues(value)
        if (values.length === 0) {
          return
        }

        const attributeFilter: AttributeWithValuesFilter = {
          type: 'attributes',
          key: filterName,
          values,
        }
        productSearchQuery.attributes?.push(attributeFilter)
        break
      }
    }
  })

  return productSearchQuery
}

export const createPlpFilterKey = (query: LocationQuery) =>
  JSON.stringify(parseAppliedFilters(query))
